import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  NavbarBrand
} from "reactstrap";
import {useHistory} from 'react-router-dom'
import {useForm} from 'react-hook-form';
import { useEffect,useState } from "react";
import { loginUser } from "redux/UserAuthentication/LoginActions";
import { connect, useDispatch } from "react-redux";
import Swal from 'sweetalert2'
import { clearloginAuthenticatedErrors } from "redux/UserAuthentication/LoginActions";
import ForgotPasswordModal from "components/Modal/ForgotPasswordModal";
import { updateForgotPassword } from "redux/UserAuthentication/ForgotPasswordActions";

import googleIcon from 'assets/img/icons/common/google.svg';
import facebookIcon from 'assets/img/icons/common/facebook.svg';
import { signInWithGoogle, signInWithFacebook } from '../../firebase';

const Login = (props) => {

  const dispatch = useDispatch();
  const history = useHistory();
  const { register, getValues, unregister,watch, handleSubmit,setValue, formState: { errors } } = useForm();
  
  const modalForgotPassword = props.updateForgotPasswordModalStatus.status;

  const toggleForgotPassword = () =>{
    dispatch(updateForgotPassword(!props.updateForgotPasswordModalStatus.status));
    
  } 

  const messageRequired = "This field is required.";

  const { ref: emailRef, ...emailRest } = register("email", {
      required: messageRequired,
      pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: "Invalid email address."
      }
  });

  const { ref: passwordRef, ...passwordRest } = register("password", { required: messageRequired });

  
  
  const onSubmit = (data) => {
    const userData = {
      email: data.email,
      password: data.password
    }
    
    dispatch(loginUser(userData));
  }


  // if(props.loginAuth.loading){
  //   Swal.fire({
  //     allowOutsideClick : false,
  //     didOpen: () => {
  //       Swal.showLoading()
        
  //     }
  //   });

  // }
  // else{
   
    
    // if(props.signupUser.signupuser.length && typeof props.signupUser.error === "undefined"){
    //   Swal.fire({
    //       title: 'Success!',
    //       text: 'Registered successfully!',
    //       icon : 'success',
    //       timer: 3000
          
    //     }
    //   ).then(function (result) {
          
    //     history.push("/auth/login");
      
    //   });

    //   dispatch(signupUserReset());
      
    // }

    if(props.loginAuth.errors != null){

      // if(props.loginAuth.error.hasOwnProperty('email')){
      
        Swal.fire({
          title:'Failed!',
          text: props.loginAuth.errors.general ? props.loginAuth.errors.general : props.loginAuth.errors ,
          icon :'error',
          timer: 3000
          
        }).finally(() => {
          dispatch(clearloginAuthenticatedErrors());       
        })

        
      // }
      // else{
      //   Swal.fire({
      //     title:'Failed!',
      //     text:'Something went wrong, Please try again!',
      //     icon :'error',
      //     timer: 3000
          
      //   })
      // }
          
      
      
    }

  // }
  
  const handleGoogleLogin = async (e) => {
    e.preventDefault()
    const signIn = await signInWithGoogle();
    // const { user, token } = await signInWithGoogle();
    // console.log('Google user:', user);
    // console.log('ID token:', token);

  };

  const handleFacebookLogin = async (e) => {
    e.preventDefault()
    const signIn = await signInWithFacebook();
    // const { user, token } = await signInWithFacebook();
    // console.log('Facebook user:', user);
    // console.log('ID token:', token);

  };


 

  return (
    <>
      
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent mb-2">
          
            {/* <div class="text-muted text-center mt-2 ">
              <small>Sign in</small>
            </div> */}
            <div className="text-muted text-center mt-2 mb-3">
              <span className="font-weight-bolder text-lg text-success">Sign In to Your Account</span>
            </div>
          </CardHeader>

          <CardBody className="px-lg-5 ">
            <div className="text-muted text-center mt-2 mb-4">
              <small>Sign in with your credentials</small>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)} role="form">
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Email"
                    type="text"
                    autoComplete="email"
                    innerRef={emailRef}
                    {...emailRest}
                  />
                </InputGroup>
                { errors.email && <small className="text-danger">{errors.email.message}</small> }
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Password"
                    type="password"
                    autoComplete="current-password"
                    innerRef={passwordRef}
                    {...passwordRest}
                  />
                </InputGroup>
                { errors.password && <small className="text-danger">{errors.password.message}</small> }
              </FormGroup>
              {/* <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id=" customCheckLogin"
                  type="checkbox"
                />
                <label
                  className="custom-control-label"
                  htmlFor=" customCheckLogin"
                >
                  <span className="text-muted">Remember me</span>
                </label>
              </div> */}
              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Sign in
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col xs="6">
            <a
              className="text-light"
              
              onClick={(e) => {e.preventDefault(); toggleForgotPassword()}}
            >
              <small>Forgot password?</small>
            </a>
          </Col>
          <Col className="text-right" xs="6">
            <a
              className="text-light"
              href="/auth/register"
              onClick={(e) => {e.preventDefault(); history.push("/auth/register");}}
            >
              <small>Create new account</small>
            </a>
          </Col>
        </Row>
      
      {/* <CoursesModal toggleForgotPassword={toggleForgotPassword} modalForgotPassword={modalForgotPassword} /> */}
      <ForgotPasswordModal modalForgotPassword={modalForgotPassword} toggleForgotPassword={toggleForgotPassword}  /> 
    </>
  );
};

const mapStateToProps = state => {
  return {
    loginAuth : state.loginAuth,
    updateForgotPasswordModalStatus : state.updateForgotPasswordModalStatus,
   
  }
}

export default connect(mapStateToProps)(Login);
